import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify(
	{
		icons:
		{
			iconfont: 'mdi'
		},
		theme:
		{
			options:
			{
				// setting this option exposes the color variables so that we can use them
				// in style blocks like this:
				// color: var(--v-primary-base);
				// where 'primary' takes the color value defined as 'primary' and 'base'
				// refers to the currently selected theme
				// there are generated variations based on the theme colors, inspect html
				// element to see all available variables
				customProperties: true,
				cspNonce: 'KOkp39JTViTcTymkuAzeiLCu',
			},
			themes:
			{
				light:
				{
					primary: '#003167',
					secondary: '#0094d5',
					tertiary: '#e30054',
					success: '#38a962',
					warning: '#e30054',
					error: '#e30054',
					info: '#0094d5',
					link: '#0094d5',

					dark: '#000000',
					light: '#ffffff',
					//background: '#ffffff',

					/* dialog buttons */
					save: '#008083',
					cancel: '#cccccc',
					delete: '#e30054',

					/* file status */
					uploaded: '#f9a825',
					missing: '#000000',
					approved: '#38a962',
					review: '#0094d5',
					rejected: '#e30054',
				},
			},
		},
	},
);